import { useEffect, useState } from 'react';
import { useStorageKeys } from '../../storage';
import { useCurrentAccount } from './useCurrentAccount';
import { useGrippContext } from '../../grippContext';
import { useCurrentWorkspace } from './useCurrentWorkspace';
import { Alert } from 'react-native';

export const useIsInImpersonateUser = () => {
  const { account } = useCurrentAccount();
  const { secureStorageHandler } = useGrippContext();
  const storageKeys = useStorageKeys();
  const [isInImpersonateUser, setIsInImpersonateUser] = useState<
    boolean | null
  >(null);

  useEffect(() => {
    if (!account) {
      return;
    }
    secureStorageHandler
      .getItem(storageKeys.oldAccessToken)
      .then((result) => {
        setIsInImpersonateUser(result ? true : false);
      })
      .catch(() => {
        setIsInImpersonateUser(false);
      });
  }, [account]);

  return isInImpersonateUser;
};

/* 
  for queries: 
    - if local storage is set, use that
    - else,
        if global admin, do nothing
          else, use account workspace
*/
